import { render, staticRenderFns } from "./CustomerFormImageUpload.vue?vue&type=template&id=c3b09c72&scoped=true"
import script from "./CustomerFormImageUpload.vue?vue&type=script&lang=js"
export * from "./CustomerFormImageUpload.vue?vue&type=script&lang=js"
import style0 from "./CustomerFormImageUpload.vue?vue&type=style&index=0&id=c3b09c72&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3b09c72",
  null
  
)

export default component.exports